import { Tooltip } from "@heroui/react";
import { Icon } from "./Icon";

const MESSAGE =
  "L'icona indica che gli articoli da questa fonte contengono allegati testuali importati e fruibili direttamente in questa piattaforma.";

/** Icona verde "file-code" con il tooltip del design ("Tooltip Open", nodo 90:4836). */
export function IngestionIcon({ className }: { className?: string }) {
  return (
    <Tooltip delay={300}>
      <Tooltip.Trigger aria-label={MESSAGE} className={`cursor-help rounded-xs ${className ?? ""}`}>
        <Icon name="fileCode" />
      </Tooltip.Trigger>
      <Tooltip.Content
        showArrow
        placement="bottom"
        className="w-[175px] rounded-xl px-2.5 py-1.5 text-xs leading-5 break-normal text-muted"
      >
        <Tooltip.Arrow />
        <p>{MESSAGE}</p>
      </Tooltip.Content>
    </Tooltip>
  );
}
